
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate-design/templates",
      function () {
        return require("private-next-pages/corporate-design/templates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate-design/templates"])
      });
    }
  